
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoiTW9yZSIsIkxlc3MiOiJMZXNzIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoiTW9yZSIsIkxlc3MiOiJMZXNzIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoi4LmB4Liq4LiU4LiH4LmA4Lie4Li04LmI4Lih4LmA4LiV4Li04LihIiwiTGVzcyI6IuC5geC4quC4lOC4h%2BC4meC5ieC4reC4ouC4peC4hyJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoi4LmB4Liq4LiU4LiH4LmA4Lie4Li04LmI4Lih4LmA4LiV4Li04LihIiwiTGVzcyI6IuC5geC4quC4lOC4h%2BC4meC5ieC4reC4ouC4peC4hyJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoiTGViaWggYmFueWFrIiwiTGVzcyI6IkxlYmloIHNlZGlraXQifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoiTGViaWggYmFueWFrIiwiTGVzcyI6IkxlYmloIHNlZGlraXQifQ%3D%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoiW%2BG5gsO2w7bFmeG6veG6vV0iLCJMZXNzIjoiW8WB4bq94bq94bq9xaHFoV0ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../virtual-resource-loader@2.0.0/node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNb3JlIjoiW%2BG5gsO2w7bFmeG6veG6vV0iLCJMZXNzIjoiW8WB4bq94bq94bq9xaHFoV0ifQ%3D%3D!"
        )
      )
      });
  
      export { translations as translations };
    